import React from 'react'

function StronaWBudowie() {
  return (
    <div className='h-screen mx-auto justify-center flex'>
        <div className='pt-[30%] text-center items-center'>
        <h3 className='text-xl'>Strona w budowie</h3>
        <p>Zapraszamy do kontaktu z ekspertami.</p>
        </div>
    </div>
  )
}

export default StronaWBudowie